<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <KuaishouBall />
  </div>
</template>

<script>
import {resetFontSize} from './utils'
import KuaishouBall from '@/components/common/KuaishouBall.vue'
// import vconsole from 'vconsole'
// new vconsole
export default {
  components: {
    KuaishouBall
  },
  async created () {
    this.initFontSize()
  },
  methods: {
    initFontSize () {
      resetFontSize()
      window.addEventListener('load', () => {
        resetFontSize()
      }, false)
      window.addEventListener('orientationchange', resetFontSize, false)
      window.addEventListener('resize', resetFontSize, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', resetFontSize, false)
    window.removeEventListener('resize', resetFontSize, false)
  }
}
</script>

<style lang="stylus">
#app
  font-family PingFang-SC Medium, Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  font-size .13rem
  background-color #F5F5F5
  max-width 750px
  margin 0 auto
  // height 100vh
  user-select none
*
  margin 0px
  padding 0px
  font-family 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif!important
html,body
  margin 0px
  padding 0px
</style>
<style lang="stylus" src="./common.styl">
</style>
